// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/user_defined_exchange_options.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { SignalFormat, SignalFormatJson } from "./signal_format_pb";
import { file_mochabugapis_adapt_graph_v1_signal_format } from "./signal_format_pb";
import type { Transmitter_Mode, Transmitter_ModeJson } from "./transmitter_pb";
import { file_mochabugapis_adapt_graph_v1_transmitter } from "./transmitter_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/user_defined_exchange_options.proto.
 */
export const file_mochabugapis_adapt_graph_v1_user_defined_exchange_options: GenFile = /*@__PURE__*/
  fileDesc("Cj9tb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdjEvdXNlcl9kZWZpbmVkX2V4Y2hhbmdlX29wdGlvbnMucHJvdG8SG21vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MSKXIQoaVXNlckRlZmluZWRFeGNoYW5nZU9wdGlvbnMSbAoTdHJhbnNtaXR0ZXJfb3B0aW9ucxgBIAEoCzJKLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5Vc2VyRGVmaW5lZEV4Y2hhbmdlT3B0aW9ucy5UcmFuc21pdHRlck9wdGlvbnNIAIgBARJmChByZWNlaXZlcl9vcHRpb25zGAIgASgLMkcubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLlVzZXJEZWZpbmVkRXhjaGFuZ2VPcHRpb25zLlJlY2VpdmVyT3B0aW9uc0gBiAEBEiMKDW1heF9leGNoYW5nZXMYAyABKAVCB7pIBBoCKABIAogBARIjCg1taW5fZXhjaGFuZ2VzGAQgASgFQge6SAQaAigASAOIAQES1AEKDmV4Y2hhbmdlX2xvY2tzGAUgAygLMkQubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLlVzZXJEZWZpbmVkRXhjaGFuZ2VPcHRpb25zLkV4Y2hhbmdlTG9ja0J2ukhzugFwChtleGNoYW5nZV9sb2Nrc191bmlxdWVfbmFtZXMSMUVhY2ggZXhjaGFuZ2UgbG9jayBtdXN0IHRhcmdldCBhIHVuaXF1ZSBleGNoYW5nZS4aHnRoaXMubWFwKGVsLCBlbC5uYW1lKS51bmlxdWUoKRqYAQoKU2lnbmFsTG9jaxIzCgRuYW1lGAEgASgJQiW6SCJyIBABGDIyGl5bXyRhLXpBLVpdW18kYS16QS1aMC05XSokEkQKDG11c3Rfc3Vic3VtZRgCIAEoCzIpLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5TaWduYWxGb3JtYXRIAIgBAUIPCg1fbXVzdF9zdWJzdW1lGpwGCg9UcmFuc21pdHRlckxvY2sSMwoEbmFtZRgBIAEoCUIlukgiciAQARgyMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBLIAQoMc2lnbmFsX2xvY2tzGAIgAygLMkIubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLlVzZXJEZWZpbmVkRXhjaGFuZ2VPcHRpb25zLlNpZ25hbExvY2tCbrpIa7oBaAoZc2lnbmFsX2xvY2tzX3VuaXF1ZV9uYW1lcxItRWFjaCBzaWduYWwgbG9jayBtdXN0IHRhcmdldCBhIHVuaXF1ZSBzaWduYWwuGhx0aGlzLm1hcChzLCBzLm5hbWUpLnVuaXF1ZSgpEiEKC21pbl9zaWduYWxzGAMgASgFQge6SAQaAigASACIAQESIQoLbWF4X3NpZ25hbHMYBCABKAVCB7pIBBoCKABIAYgBARJHCgtsb2NrZWRfbW9kZRgFIAEoDjItLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5UcmFuc21pdHRlci5Nb2RlSAKIAQE6yQK6SMUCGqMBCg9taW5fbWF4X3NpZ25hbHMSNm1pbl9zaWduYWxzIG11c3QgYmUgbGVzcyB0aGFuIG9yIGVxdWFsIHRvIG1heF9zaWduYWxzLhpYIWhhcyh0aGlzLm1pbl9zaWduYWxzKSB8fCAhaGFzKHRoaXMubWF4X3NpZ25hbHMpIHx8IHRoaXMubWluX3NpZ25hbHMgPD0gdGhpcy5tYXhfc2lnbmFscxqcAQoWbWluX3NpZ25hbHNfZ3RlX2xvY2tlZBI6bWluX3NpZ25hbHMgbXVzdCBiZSBhdCBsZWFzdCB0aGUgbnVtYmVyIG9mIGxvY2tlZCBzaWduYWxzLhpGIWhhcyh0aGlzLm1pbl9zaWduYWxzKSB8fCB0aGlzLm1pbl9zaWduYWxzID49IHRoaXMuc2lnbmFsX2xvY2tzLnNpemUoKUIOCgxfbWluX3NpZ25hbHNCDgoMX21heF9zaWduYWxzQg4KDF9sb2NrZWRfbW9kZRrABQoMUmVjZWl2ZXJMb2NrEjMKBG5hbWUYASABKAlCJbpIInIgEAEYMjIaXltfJGEtekEtWl1bXyRhLXpBLVowLTldKiQSyAEKDHNpZ25hbF9sb2NrcxgCIAMoCzJCLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5Vc2VyRGVmaW5lZEV4Y2hhbmdlT3B0aW9ucy5TaWduYWxMb2NrQm66SGu6AWgKGXNpZ25hbF9sb2Nrc191bmlxdWVfbmFtZXMSLUVhY2ggc2lnbmFsIGxvY2sgbXVzdCB0YXJnZXQgYSB1bmlxdWUgc2lnbmFsLhocdGhpcy5tYXAocywgcy5uYW1lKS51bmlxdWUoKRIhCgttaW5fc2lnbmFscxgDIAEoBUIHukgEGgIoAEgAiAEBEiEKC21heF9zaWduYWxzGAQgASgFQge6SAQaAigASAGIAQE6yQK6SMUCGqMBCg9taW5fbWF4X3NpZ25hbHMSNm1pbl9zaWduYWxzIG11c3QgYmUgbGVzcyB0aGFuIG9yIGVxdWFsIHRvIG1heF9zaWduYWxzLhpYIWhhcyh0aGlzLm1pbl9zaWduYWxzKSB8fCAhaGFzKHRoaXMubWF4X3NpZ25hbHMpIHx8IHRoaXMubWluX3NpZ25hbHMgPD0gdGhpcy5tYXhfc2lnbmFscxqcAQoWbWluX3NpZ25hbHNfZ3RlX2xvY2tlZBI6bWluX3NpZ25hbHMgbXVzdCBiZSBhdCBsZWFzdCB0aGUgbnVtYmVyIG9mIGxvY2tlZCBzaWduYWxzLhpGIWhhcyh0aGlzLm1pbl9zaWduYWxzKSB8fCB0aGlzLm1pbl9zaWduYWxzID49IHRoaXMuc2lnbmFsX2xvY2tzLnNpemUoKUIOCgxfbWluX3NpZ25hbHNCDgoMX21heF9zaWduYWxzGo0GChJUcmFuc21pdHRlck9wdGlvbnMSHAoPYWxsb3dfc3RyZWFtaW5nGAEgASgISACIAQESyQEKBWxvY2tzGAIgAygLMkcubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLlVzZXJEZWZpbmVkRXhjaGFuZ2VPcHRpb25zLlRyYW5zbWl0dGVyTG9ja0JxukhuugFrChJsb2Nrc191bmlxdWVfbmFtZXMSN0VhY2ggdHJhbnNtaXR0ZXIgbG9jayBtdXN0IHRhcmdldCBhIHVuaXF1ZSB0cmFuc21pdHRlci4aHHRoaXMubWFwKGwsIGwubmFtZSkudW5pcXVlKCkSJgoQbWluX3RyYW5zbWl0dGVycxgDIAEoBUIHukgEGgIoAEgBiAEBEiYKEG1heF90cmFuc21pdHRlcnMYBCABKAVCB7pIBBoCKABIAogBATr+ArpI+gIaxgEKFG1pbl9tYXhfdHJhbnNtaXR0ZXJzEkBtaW5fdHJhbnNtaXR0ZXJzIG11c3QgYmUgbGVzcyB0aGFuIG9yIGVxdWFsIHRvIG1heF90cmFuc21pdHRlcnMuGmwhaGFzKHRoaXMubWluX3RyYW5zbWl0dGVycykgfHwgIWhhcyh0aGlzLm1heF90cmFuc21pdHRlcnMpIHx8IHRoaXMubWluX3RyYW5zbWl0dGVycyA8PSB0aGlzLm1heF90cmFuc21pdHRlcnMargEKG21pbl90cmFuc21pdHRlcnNfZ3RlX2xvY2tlZBJEbWluX3RyYW5zbWl0dGVycyBtdXN0IGJlIGF0IGxlYXN0IHRoZSBudW1iZXIgb2YgbG9ja2VkIHRyYW5zbWl0dGVycy4aSSFoYXModGhpcy5taW5fdHJhbnNtaXR0ZXJzKSB8fCB0aGlzLm1pbl90cmFuc21pdHRlcnMgPj0gdGhpcy5sb2Nrcy5zaXplKClCEgoQX2FsbG93X3N0cmVhbWluZ0ITChFfbWluX3RyYW5zbWl0dGVyc0ITChFfbWF4X3RyYW5zbWl0dGVycxqfBQoPUmVjZWl2ZXJPcHRpb25zEsABCgVsb2NrcxgBIAMoCzJELm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC52MS5Vc2VyRGVmaW5lZEV4Y2hhbmdlT3B0aW9ucy5SZWNlaXZlckxvY2tCa7pIaLoBZQoSbG9ja3NfdW5pcXVlX25hbWVzEjFFYWNoIHJlY2VpdmVyIGxvY2sgbXVzdCB0YXJnZXQgYSB1bmlxdWUgcmVjZWl2ZXIuGhx0aGlzLm1hcChsLCBsLm5hbWUpLnVuaXF1ZSgpEiMKDW1pbl9yZWNlaXZlcnMYAiABKAVCB7pIBBoCKABIAIgBARIjCg1tYXhfcmVjZWl2ZXJzGAMgASgFQge6SAQaAigASAGIAQE62gK6SNYCGrEBChFtaW5fbWF4X3JlY2VpdmVycxI6bWluX3JlY2VpdmVycyBtdXN0IGJlIGxlc3MgdGhhbiBvciBlcXVhbCB0byBtYXhfcmVjZWl2ZXJzLhpgIWhhcyh0aGlzLm1pbl9yZWNlaXZlcnMpIHx8ICFoYXModGhpcy5tYXhfcmVjZWl2ZXJzKSB8fCB0aGlzLm1pbl9yZWNlaXZlcnMgPD0gdGhpcy5tYXhfcmVjZWl2ZXJzGp8BChhtaW5fcmVjZWl2ZXJzX2d0ZV9sb2NrZWQSPm1pbl9yZWNlaXZlcnMgbXVzdCBiZSBhdCBsZWFzdCB0aGUgbnVtYmVyIG9mIGxvY2tlZCByZWNlaXZlcnMuGkMhaGFzKHRoaXMubWluX3JlY2VpdmVycykgfHwgdGhpcy5taW5fcmVjZWl2ZXJzID49IHRoaXMubG9ja3Muc2l6ZSgpQhAKDl9taW5fcmVjZWl2ZXJzQhAKDl9tYXhfcmVjZWl2ZXJzGsYCCgxFeGNoYW5nZUxvY2sSMwoEbmFtZRgBIAEoCUIlukgiciAQARgyMhpeW18kYS16QS1aXVtfJGEtekEtWjAtOV0qJBJsChN0cmFuc21pdHRlcl9vcHRpb25zGAIgASgLMkoubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLlVzZXJEZWZpbmVkRXhjaGFuZ2VPcHRpb25zLlRyYW5zbWl0dGVyT3B0aW9uc0gAiAEBEmYKEHJlY2VpdmVyX29wdGlvbnMYAyABKAsyRy5tb2NoYWJ1Z2FwaXMuYWRhcHQuZ3JhcGgudjEuVXNlckRlZmluZWRFeGNoYW5nZU9wdGlvbnMuUmVjZWl2ZXJPcHRpb25zSAGIAQFCFgoUX3RyYW5zbWl0dGVyX29wdGlvbnNCEwoRX3JlY2VpdmVyX29wdGlvbnM6uAG6SLQBGrEBChFtaW5fbWF4X2V4Y2hhbmdlcxI6bWluX2V4Y2hhbmdlcyBtdXN0IGJlIGxlc3MgdGhhbiBvciBlcXVhbCB0byBtYXhfZXhjaGFuZ2VzLhpgIWhhcyh0aGlzLm1pbl9leGNoYW5nZXMpIHx8ICFoYXModGhpcy5tYXhfZXhjaGFuZ2VzKSB8fCB0aGlzLm1pbl9leGNoYW5nZXMgPD0gdGhpcy5tYXhfZXhjaGFuZ2VzQhYKFF90cmFuc21pdHRlcl9vcHRpb25zQhMKEV9yZWNlaXZlcl9vcHRpb25zQhAKDl9tYXhfZXhjaGFuZ2VzQhAKDl9taW5fZXhjaGFuZ2VzYgZwcm90bzM", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_signal_format, file_mochabugapis_adapt_graph_v1_transmitter]);

/**
 * UserDefinedExchangeOptions configures if and how users can create their own
 * exchanges on a vertex at graph construction time.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions
 */
export type UserDefinedExchangeOptions = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions"> & {
  /**
   * Restrictions on the output side of user-defined exchanges.
   * Unset = no restrictions beyond Exchange's own validation.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions transmitter_options = 1;
   */
  transmitterOptions?: UserDefinedExchangeOptions_TransmitterOptions | undefined;

  /**
   * Restrictions on the input side of user-defined exchanges.
   * Unset = no restrictions beyond Exchange's own validation.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions receiver_options = 2;
   */
  receiverOptions?: UserDefinedExchangeOptions_ReceiverOptions | undefined;

  /**
   * Maximum number of user-defined exchanges allowed. Unset = no limit.
   *
   * @generated from field: optional int32 max_exchanges = 3;
   */
  maxExchanges?: number | undefined;

  /**
   * Minimum number of user-defined exchanges required. Unset = no minimum.
   *
   * @generated from field: optional int32 min_exchanges = 4;
   */
  minExchanges?: number | undefined;

  /**
   * Locks on specific plugin-defined exchanges.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ExchangeLock exchange_locks = 5;
   */
  exchangeLocks: UserDefinedExchangeOptions_ExchangeLock[];
};

/**
 * UserDefinedExchangeOptions configures if and how users can create their own
 * exchanges on a vertex at graph construction time.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions
 */
export type UserDefinedExchangeOptionsJson = {
  /**
   * Restrictions on the output side of user-defined exchanges.
   * Unset = no restrictions beyond Exchange's own validation.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions transmitter_options = 1;
   */
  transmitterOptions?: UserDefinedExchangeOptions_TransmitterOptionsJson;

  /**
   * Restrictions on the input side of user-defined exchanges.
   * Unset = no restrictions beyond Exchange's own validation.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions receiver_options = 2;
   */
  receiverOptions?: UserDefinedExchangeOptions_ReceiverOptionsJson;

  /**
   * Maximum number of user-defined exchanges allowed. Unset = no limit.
   *
   * @generated from field: optional int32 max_exchanges = 3;
   */
  maxExchanges?: number;

  /**
   * Minimum number of user-defined exchanges required. Unset = no minimum.
   *
   * @generated from field: optional int32 min_exchanges = 4;
   */
  minExchanges?: number;

  /**
   * Locks on specific plugin-defined exchanges.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ExchangeLock exchange_locks = 5;
   */
  exchangeLocks?: UserDefinedExchangeOptions_ExchangeLockJson[];
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.
 * Use `create(UserDefinedExchangeOptionsSchema)` to create a new message.
 */
export const UserDefinedExchangeOptionsSchema: GenMessage<UserDefinedExchangeOptions, {jsonType: UserDefinedExchangeOptionsJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0);

/**
 * SignalLock constrains a specific signal within a transmitter or receiver.
 * Presence means the signal is locked. Fields grant exceptions.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock
 */
export type UserDefinedExchangeOptions_SignalLock = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock"> & {
  /**
   * Name of the signal to lock.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * If set, the user can modify this signal's format but their format must
   * subsume this base format. If unset, the signal is fully locked.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.SignalFormat must_subsume = 2;
   */
  mustSubsume?: SignalFormat | undefined;
};

/**
 * SignalLock constrains a specific signal within a transmitter or receiver.
 * Presence means the signal is locked. Fields grant exceptions.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock
 */
export type UserDefinedExchangeOptions_SignalLockJson = {
  /**
   * Name of the signal to lock.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * If set, the user can modify this signal's format but their format must
   * subsume this base format. If unset, the signal is fully locked.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.SignalFormat must_subsume = 2;
   */
  mustSubsume?: SignalFormatJson;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock.
 * Use `create(UserDefinedExchangeOptions_SignalLockSchema)` to create a new message.
 */
export const UserDefinedExchangeOptions_SignalLockSchema: GenMessage<UserDefinedExchangeOptions_SignalLock, {jsonType: UserDefinedExchangeOptions_SignalLockJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0, 0);

/**
 * TransmitterLock opens up a specific named output transmitter within a
 * locked exchange. Transmitters NOT listed in locks are fully frozen.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterLock
 */
export type UserDefinedExchangeOptions_TransmitterLock = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterLock"> & {
  /**
   * Name of the transmitter to open up.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Signals that remain locked within this transmitter.
   * Unlisted signals are free to modify.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock signal_locks = 2;
   */
  signalLocks: UserDefinedExchangeOptions_SignalLock[];

  /**
   * Minimum total signals (including locked ones). Unset = no minimum.
   *
   * @generated from field: optional int32 min_signals = 3;
   */
  minSignals?: number | undefined;

  /**
   * Maximum total signals (including locked ones). Unset = no maximum.
   *
   * @generated from field: optional int32 max_signals = 4;
   */
  maxSignals?: number | undefined;

  /**
   * Pin the user-defined transmitter to this specific mode. If unset, the
   * user picks any mode they want (subject to the parent TransmitterOptions
   * gates).
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.Transmitter.Mode locked_mode = 5;
   */
  lockedMode?: Transmitter_Mode | undefined;
};

/**
 * TransmitterLock opens up a specific named output transmitter within a
 * locked exchange. Transmitters NOT listed in locks are fully frozen.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterLock
 */
export type UserDefinedExchangeOptions_TransmitterLockJson = {
  /**
   * Name of the transmitter to open up.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Signals that remain locked within this transmitter.
   * Unlisted signals are free to modify.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock signal_locks = 2;
   */
  signalLocks?: UserDefinedExchangeOptions_SignalLockJson[];

  /**
   * Minimum total signals (including locked ones). Unset = no minimum.
   *
   * @generated from field: optional int32 min_signals = 3;
   */
  minSignals?: number;

  /**
   * Maximum total signals (including locked ones). Unset = no maximum.
   *
   * @generated from field: optional int32 max_signals = 4;
   */
  maxSignals?: number;

  /**
   * Pin the user-defined transmitter to this specific mode. If unset, the
   * user picks any mode they want (subject to the parent TransmitterOptions
   * gates).
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.Transmitter.Mode locked_mode = 5;
   */
  lockedMode?: Transmitter_ModeJson;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterLock.
 * Use `create(UserDefinedExchangeOptions_TransmitterLockSchema)` to create a new message.
 */
export const UserDefinedExchangeOptions_TransmitterLockSchema: GenMessage<UserDefinedExchangeOptions_TransmitterLock, {jsonType: UserDefinedExchangeOptions_TransmitterLockJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0, 1);

/**
 * ReceiverLock opens up a specific named input receiver within a locked
 * exchange. Receivers NOT listed in locks are fully frozen. Inputs have no
 * mode/streaming concept, so this is simpler than TransmitterLock.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverLock
 */
export type UserDefinedExchangeOptions_ReceiverLock = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverLock"> & {
  /**
   * Name of the receiver to open up.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Signals that remain locked within this receiver.
   * Unlisted signals are free to modify.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock signal_locks = 2;
   */
  signalLocks: UserDefinedExchangeOptions_SignalLock[];

  /**
   * Minimum total signals (including locked ones). Unset = no minimum.
   *
   * @generated from field: optional int32 min_signals = 3;
   */
  minSignals?: number | undefined;

  /**
   * Maximum total signals (including locked ones). Unset = no maximum.
   *
   * @generated from field: optional int32 max_signals = 4;
   */
  maxSignals?: number | undefined;
};

/**
 * ReceiverLock opens up a specific named input receiver within a locked
 * exchange. Receivers NOT listed in locks are fully frozen. Inputs have no
 * mode/streaming concept, so this is simpler than TransmitterLock.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverLock
 */
export type UserDefinedExchangeOptions_ReceiverLockJson = {
  /**
   * Name of the receiver to open up.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Signals that remain locked within this receiver.
   * Unlisted signals are free to modify.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.SignalLock signal_locks = 2;
   */
  signalLocks?: UserDefinedExchangeOptions_SignalLockJson[];

  /**
   * Minimum total signals (including locked ones). Unset = no minimum.
   *
   * @generated from field: optional int32 min_signals = 3;
   */
  minSignals?: number;

  /**
   * Maximum total signals (including locked ones). Unset = no maximum.
   *
   * @generated from field: optional int32 max_signals = 4;
   */
  maxSignals?: number;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverLock.
 * Use `create(UserDefinedExchangeOptions_ReceiverLockSchema)` to create a new message.
 */
export const UserDefinedExchangeOptions_ReceiverLockSchema: GenMessage<UserDefinedExchangeOptions_ReceiverLock, {jsonType: UserDefinedExchangeOptions_ReceiverLockJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0, 2);

/**
 * TransmitterOptions restricts the output side of user-defined exchanges.
 * Streaming is gated (real fork-explosion concern); failure mode is not
 * gated at this level because it's a per-transmitter property without a
 * similar cost. Use TransmitterLock.locked_mode if a specific transmitter
 * must declare a particular mode.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions
 */
export type UserDefinedExchangeOptions_TransmitterOptions = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions"> & {
  /**
   * Whether streaming transmitters are allowed.
   * Unset or true = allowed. False = forbidden.
   *
   * @generated from field: optional bool allow_streaming = 1;
   */
  allowStreaming?: boolean | undefined;

  /**
   * Transmitter locks. Each entry opens up a specific transmitter.
   * In a locked exchange, transmitters NOT listed here are fully frozen.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterLock locks = 2;
   */
  locks: UserDefinedExchangeOptions_TransmitterLock[];

  /**
   * Minimum number of transmitters. Unset = no minimum.
   *
   * @generated from field: optional int32 min_transmitters = 3;
   */
  minTransmitters?: number | undefined;

  /**
   * Maximum number of transmitters. Unset = no maximum.
   *
   * @generated from field: optional int32 max_transmitters = 4;
   */
  maxTransmitters?: number | undefined;
};

/**
 * TransmitterOptions restricts the output side of user-defined exchanges.
 * Streaming is gated (real fork-explosion concern); failure mode is not
 * gated at this level because it's a per-transmitter property without a
 * similar cost. Use TransmitterLock.locked_mode if a specific transmitter
 * must declare a particular mode.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions
 */
export type UserDefinedExchangeOptions_TransmitterOptionsJson = {
  /**
   * Whether streaming transmitters are allowed.
   * Unset or true = allowed. False = forbidden.
   *
   * @generated from field: optional bool allow_streaming = 1;
   */
  allowStreaming?: boolean;

  /**
   * Transmitter locks. Each entry opens up a specific transmitter.
   * In a locked exchange, transmitters NOT listed here are fully frozen.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterLock locks = 2;
   */
  locks?: UserDefinedExchangeOptions_TransmitterLockJson[];

  /**
   * Minimum number of transmitters. Unset = no minimum.
   *
   * @generated from field: optional int32 min_transmitters = 3;
   */
  minTransmitters?: number;

  /**
   * Maximum number of transmitters. Unset = no maximum.
   *
   * @generated from field: optional int32 max_transmitters = 4;
   */
  maxTransmitters?: number;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions.
 * Use `create(UserDefinedExchangeOptions_TransmitterOptionsSchema)` to create a new message.
 */
export const UserDefinedExchangeOptions_TransmitterOptionsSchema: GenMessage<UserDefinedExchangeOptions_TransmitterOptions, {jsonType: UserDefinedExchangeOptions_TransmitterOptionsJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0, 3);

/**
 * ReceiverOptions restricts the input side of user-defined exchanges. Inputs
 * have no mode/streaming concept, so there are no allow-flags here.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions
 */
export type UserDefinedExchangeOptions_ReceiverOptions = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions"> & {
  /**
   * Receiver locks. Each entry opens up a specific receiver.
   * In a locked exchange, receivers NOT listed here are fully frozen.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverLock locks = 1;
   */
  locks: UserDefinedExchangeOptions_ReceiverLock[];

  /**
   * Minimum number of receivers. Unset = no minimum.
   *
   * @generated from field: optional int32 min_receivers = 2;
   */
  minReceivers?: number | undefined;

  /**
   * Maximum number of receivers. Unset = no maximum.
   *
   * @generated from field: optional int32 max_receivers = 3;
   */
  maxReceivers?: number | undefined;
};

/**
 * ReceiverOptions restricts the input side of user-defined exchanges. Inputs
 * have no mode/streaming concept, so there are no allow-flags here.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions
 */
export type UserDefinedExchangeOptions_ReceiverOptionsJson = {
  /**
   * Receiver locks. Each entry opens up a specific receiver.
   * In a locked exchange, receivers NOT listed here are fully frozen.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverLock locks = 1;
   */
  locks?: UserDefinedExchangeOptions_ReceiverLockJson[];

  /**
   * Minimum number of receivers. Unset = no minimum.
   *
   * @generated from field: optional int32 min_receivers = 2;
   */
  minReceivers?: number;

  /**
   * Maximum number of receivers. Unset = no maximum.
   *
   * @generated from field: optional int32 max_receivers = 3;
   */
  maxReceivers?: number;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions.
 * Use `create(UserDefinedExchangeOptions_ReceiverOptionsSchema)` to create a new message.
 */
export const UserDefinedExchangeOptions_ReceiverOptionsSchema: GenMessage<UserDefinedExchangeOptions_ReceiverOptions, {jsonType: UserDefinedExchangeOptions_ReceiverOptionsJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0, 4);

/**
 * ExchangeLock locks a plugin-defined exchange.
 * If neither transmitter_options nor receiver_options is set, the entire
 * exchange is locked. If set, only the specified transmitters/receivers/
 * signals are locked and users can add/remove the rest.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ExchangeLock
 */
export type UserDefinedExchangeOptions_ExchangeLock = Message<"mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ExchangeLock"> & {
  /**
   * Name of the exchange to lock.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Locks on output transmitters within this exchange.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions transmitter_options = 2;
   */
  transmitterOptions?: UserDefinedExchangeOptions_TransmitterOptions | undefined;

  /**
   * Locks on input receivers within this exchange.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions receiver_options = 3;
   */
  receiverOptions?: UserDefinedExchangeOptions_ReceiverOptions | undefined;
};

/**
 * ExchangeLock locks a plugin-defined exchange.
 * If neither transmitter_options nor receiver_options is set, the entire
 * exchange is locked. If set, only the specified transmitters/receivers/
 * signals are locked and users can add/remove the rest.
 *
 * @generated from message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ExchangeLock
 */
export type UserDefinedExchangeOptions_ExchangeLockJson = {
  /**
   * Name of the exchange to lock.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Locks on output transmitters within this exchange.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.TransmitterOptions transmitter_options = 2;
   */
  transmitterOptions?: UserDefinedExchangeOptions_TransmitterOptionsJson;

  /**
   * Locks on input receivers within this exchange.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ReceiverOptions receiver_options = 3;
   */
  receiverOptions?: UserDefinedExchangeOptions_ReceiverOptionsJson;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions.ExchangeLock.
 * Use `create(UserDefinedExchangeOptions_ExchangeLockSchema)` to create a new message.
 */
export const UserDefinedExchangeOptions_ExchangeLockSchema: GenMessage<UserDefinedExchangeOptions_ExchangeLock, {jsonType: UserDefinedExchangeOptions_ExchangeLockJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_user_defined_exchange_options, 0, 5);

